var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { Stack } from 'office-ui-fabric-react';
import { TodoListItem } from './TodoListItem';
import { connect } from 'react-redux';
var TodoList = function (props) {
    var filter = props.filter, todos = props.todos;
    var filteredTodos = Object.keys(todos).filter(function (id) {
        return filter === 'all' || (filter === 'completed' && todos[id].completed) || (filter === 'active' && !todos[id].completed);
    });
    return (React.createElement(Stack, { gap: 10 }, filteredTodos.map(function (id) { return (React.createElement(TodoListItem, { key: id, id: id })); })));
};
var ConnectedTodoList = connect(function (state) { return (__assign({}, state)); })(TodoList);
export { ConnectedTodoList as TodoList };
